import { defineChatPlace } from '../../chat/panel';

/** The chat docked beside the Lead-to-Cash monitor. */
export const l2cChat = defineChatPlace({
  id: 'lead_to_cash',
  place: 'docked',
  results: 'inline',
  features: {
    sqlApproval: true,
    voiceCalls: false,
    addToDashboard: true,
    copy: true,
    contextChips: false,
  },
  welcome: {
    title: 'Lead-to-Cash Copilot',
    subtitle: 'Ask about chain health, stage metrics, and root causes for the current view.',
  },
  starters: [
    'Summarize chain health vs prior week',
    "What's driving the red stages?",
    'Why did the selected stage change?',
    'Which stage should we focus on first?',
  ],
  placeholder: 'Ask about the chain…',
});
